// extracted by mini-css-extract-plugin
export default {"signUp_cta":"styles_signUp_cta__oKARC","resendText":"styles_resendText__4gG+1"};